<template>
  <div id='' class='gPageBorder'>
    <el-button class='gSgLeftBtn' @click='add' type=primary>{{$t('app_animateMake')}}</el-button>

    <div id=''>
      <el-table
      class='gTopMg'
	    :data="tableData"
	    border
	    tooltip-effect="dark"
	    style="width: 100%">
  	    <el-table-column
          align=center
  	      prop='animatName'
  	      :label="$t('app_name')"
  	      width="">
  	    </el-table-column>
  	    <el-table-column
          align=center
  	      prop="animatType"
  	      :label="$t('app_type')"
  	      width="">
          <template slot-scope='scope'>
            <label>{{aType[scope.row.animatType]}}</label>
          </template>
  	    </el-table-column>

        <el-table-column
          align=center
          prop="mechName"
          :label="$t('app_distributor')"
          width=''>
        </el-table-column>

        <el-table-column
          align=center
          prop="pushTimes"
          :label="$t('app_pushTimes')"
          width=''>
        </el-table-column>
  	    <el-table-column
          align=center
  	      prop="createTime"
  	      :label="$t('app_customsTime')"
  	      width='175'>
  	    </el-table-column>
  	    <el-table-column
  	      prop="operate"
          align=center
  	      :label="$t('app_operate')"
  	      width='106'>
  	      <template slot-scope='scope'>

            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
              <el-button type='text' @click='push(scope.row)'><i class="fa fa-upload" style="color:#20A0FF"></i></el-button>
					  </el-tooltip> -->

            <el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
              <el-button style="color:#FF4949" type='text' @click='deleteRow(scope.row)'><i class="fa fa-trash"></i></el-button>
					  </el-tooltip>

            


            <!-- <el-tooltip class="item" effect="dark" :content="$t('app_viewPushHis')" placement="top">
              <el-button type='text' @click='viewPush(scope.row)'><i class="fa fa-clock-o" style="color:#20A0FF"></i></el-button>
					  </el-tooltip> -->


  	      </template>
  	    </el-table-column>
  	  </el-table>
    </div>

    <div class="gPgDiv" style=''>

      <el-pagination
      @current-change="pageSelect"
      @size-change="pageSized"
      :current-page="page"
      :page-sizes='$gRows'
      :page-size="$gRow"
      class='gPg'
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
      </el-pagination>

    </div>

  </div>
</template>

<style>
  #oa{}
</style>

<script>
  export default{
    data () {
      return {
        row: this.$gRow,
        total: 0,
        page: 1,
        tableData: [],
        aType: {'1': this.$t('app_launchAnimate'), '2': this.$t('app_onLogo'), '3': this.$t('app_deskwp')}
      }
    },
    components: {},
    computed: {
    },
    methods: {
      pageSelect (index) {
        this.page = index
        this.getList()
      },
      pageSized (val) {
        this.$gRow = val
        this.getList()
      },
      viewPush (row) {
        this.$setWObj('animatePushInfo', row)
        //this.$router.push({name: this.$t('menu.sysManageSub.pushHistory')})
      },
      push (row) {
        this.$setWObj('pushList', {type: '6' ,data:row})
        this.$router.push({path: '/animate-push'})
      },
      add () {
        // /animate-add
        this.$router.push({path: '/animate-add'})
        //this.$router.push({name: this.$t('menu.sysManageSub.animateCustom')})
      },
      deleteRow (row) {
        this.$showConfirm(this.$t('app_tip'), this.$t('app_sureDelTip'), this.$t('app_sure'), this.$t('app_cancel'), 'warning', () => {
          this.loading = 1
          this.$delAnimate(row.animatId, (res) => {
            this.loading = 0
            if (res.status === 200) {
              this.getList()
            } else {
              this.$message.error(res.message)
            }
          }, () => {
            this.loading = 0
            // error
          })
        }, '')
      },
      getList () {
        this.loading = 1
        this.$animateList(this.$gRow, this.page, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.tableData = res.data
            this.total = res.total
          }
        }, () => {
          // error
          this.loading = 0
        })
      }
    },
    mounted () {
      this.getList()
    }
  }
</script>



// WEBPACK FOOTER //
// onOffAnimate.vue?ed74af94